/**
 *  ? url pada submenu menggunakan naming routes
 */
export default [
  {
    icon: "UserIcon",
    menu: "Pegawai",
    url: "data-pegawai",
    group: "Data Pegawai",
  },
  {
    icon: "UserCheckIcon",
    menu: "Dosen",
    url: "kepegawaian-dosen",
    group: "Data Pegawai",
  },
  {
    icon: "CheckCircleIcon",
    menu: "Absensi",
    url: "kepegawaian-absensi",
    group: "Presensi & Kinerja",
  },
  {
    icon: "PieChartIcon",
    menu: "Reporting",
    url: "kepegawaian-reporting",
    group: "Presensi & Kinerja",
  },
];
